import React, { useState, useImperativeHandle, forwardRef } from "react";
import PageElevator from "./pages/PageElevator";

const ElevatorSection = forwardRef(
  (
    {
      inputValues,
      onValidationResult,
      onElevatorFileChange,
      onWarningMessage,
      setMediaExtensions
    },
    ref
  ) => {
    // Elevator-specific state and handlers
    const [elevatorFile, setElevatorFile] = useState({});
    const [svgFile, setSvgFile] = useState({});
    const [standardAdFile, setStandardAdFile] = useState({});
    // const [mediaExtensions, setMediaExtensions] = useState({}); //* this is now a prop, we never used mediaExtensions here anyway so we only needed the setter
    const [continueButtonDisabled, setContinueButtonDisabled] = useState(false);
    console.log(`what is continueButtonDisabled(${continueButtonDisabled}`); //* continueButtonDisabled seems to be unused? remove it?

    const handleDropzoneChanges = (name, value, droppedFileType) => {
      if (droppedFileType === "svg") {
        setSvgFile(prevState => ({ ...prevState, [name]: value }));
      } else if (droppedFileType === "standardAd") {
        setStandardAdFile(prevState => ({ ...prevState, [name]: value }));
      } else if (droppedFileType === "elevator") {
        setElevatorFile(prevState => ({ ...prevState, [name]: value }));
      }

      // svg, standardAd, elevator, landscape, portrait
      if (name === "name") {
        console.log("running split");
        const splitValue = value.split(".");
        setMediaExtensions(prevState => ({
          ...prevState,
          [droppedFileType]: splitValue[splitValue.length - 1]
        }));
      }
    };

    // Notify parent when elevatorFile changes (top-level effect)
    React.useEffect(() => {
      if (onElevatorFileChange) onElevatorFileChange(elevatorFile);
    }, [elevatorFile]);

    const handleWarningMessageText = (txt, showIcon) => {
      if (onWarningMessage) {
        onWarningMessage(txt, showIcon);
      }
    };

    const handleContinueButtonDisabled = bool => {
      setContinueButtonDisabled(bool);
    };

    // Example validation logic (customize as needed)
    const validate = () => {
      let errors = [];
      if (!elevatorFile.payload) errors.push("Elevator file missing");
      // Add more validation as needed
      handleWarningMessageText(errors.join(", "), errors.length > 0);
      return errors.length === 0;
    };

    // Real file creation logic
    const createFiles = () => {
      // Example: Generate HTML, manifest, and asset files
      // Use inputValues and dropped files (elevatorFile, svgFile, standardAdFile)
      const results = {};
      // HTML file
      if (elevatorFile.payload) {
        results.html = `<html><body><img src='${elevatorFile.payload.name}' /></body></html>`;
      }
      // Manifest file
      results.manifest = {
        creativeID: inputValues.creativeID,
        elevatorAsset: elevatorFile.payload ? elevatorFile.payload.name : null,
        svgAsset: svgFile.payload ? svgFile.payload.name : null,
        standardAdAsset: standardAdFile.payload
          ? standardAdFile.payload.name
          : null
      };
      // Asset files
      results.assets = [];
      if (elevatorFile.payload) results.assets.push(elevatorFile.payload);
      if (svgFile.payload) results.assets.push(svgFile.payload);
      if (standardAdFile.payload) results.assets.push(standardAdFile.payload);
      // Return results for parent to use
      return results;
    };

    // Expose validate and createFiles to parent via ref
    useImperativeHandle(ref, () => ({
      validate,
      createFiles
    }));

    return (
      <div className="adBuildingPageContent elevator">
        {/* elevator */}
        <div id={"screenGrabElevator"} className={`adBuildingPageInner`}>
          <PageElevator
            handleDropzoneChanges={handleDropzoneChanges}
            handleWarningMessageText={handleWarningMessageText}
            handleContinueButtonDisabled={handleContinueButtonDisabled}
          />
        </div>
        {/* Add more elevator-specific UI or logic here */}
      </div>
    );
  }
);

export default ElevatorSection;
